export default {
      id: "icon--tiny-tubing-usage",
      viewBox: "0 0 31 31",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--tiny-tubing-usage",
      toString: function () {
        return this.url;
      }
    }